import { c as _c } from "react/compiler-runtime";
import { memo, useMemo } from "react";
import { TypedNotification } from "@/types/feed.types";
import NotificationItem from "./NotificationItem";
import { ActiveDropState } from "@/types/dropInteractionTypes";
import { DropInteractionParams } from "@/components/waves/drops/Drop";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
interface NotificationItemsProps {
  readonly items: TypedNotification[];
  readonly activeDrop: ActiveDropState | null;
  readonly onReply: (param: DropInteractionParams) => void;
  readonly onQuote: (param: DropInteractionParams) => void;
  readonly onDropContentClick?: (drop: ExtendedDrop) => void;
}
function NotificationItemsComponent(t0) {
  const $ = _c(15);
  const {
    items,
    activeDrop,
    onReply,
    onQuote,
    onDropContentClick
  } = t0;
  let t1;
  if ($[0] !== items) {
    t1 = items.map(_temp);
    $[0] = items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const keyedNotifications = t1;
  let t2;
  if ($[2] !== activeDrop || $[3] !== keyedNotifications || $[4] !== onDropContentClick || $[5] !== onQuote || $[6] !== onReply) {
    let t3;
    if ($[8] !== activeDrop || $[9] !== onDropContentClick || $[10] !== onQuote || $[11] !== onReply) {
      t3 = t4 => {
        const {
          notification: notification_0,
          key,
          domId
        } = t4;
        return <div key={key} id={domId}><NotificationItem notification={notification_0} activeDrop={activeDrop} onReply={onReply} onQuote={onQuote} onDropContentClick={onDropContentClick} /></div>;
      };
      $[8] = activeDrop;
      $[9] = onDropContentClick;
      $[10] = onQuote;
      $[11] = onReply;
      $[12] = t3;
    } else {
      t3 = $[12];
    }
    t2 = keyedNotifications.map(t3);
    $[2] = activeDrop;
    $[3] = keyedNotifications;
    $[4] = onDropContentClick;
    $[5] = onQuote;
    $[6] = onReply;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[13] !== t2) {
    t3 = <div className="tw-flex tw-flex-col tw-space-y-3 tw-pb-3 lg:tw-pr-2">{t2}</div>;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
}
function _temp(notification, index) {
  const keySuffix = notification.id ?? `fallback-${index}`;
  return {
    notification,
    key: `notification-${keySuffix}`,
    domId: `feed-item-${keySuffix}`
  };
}
const NotificationItems = memo(NotificationItemsComponent, (prevProps, nextProps) => {
  return prevProps.items === nextProps.items && prevProps.activeDrop === nextProps.activeDrop && prevProps.onReply === nextProps.onReply && prevProps.onQuote === nextProps.onQuote && prevProps.onDropContentClick === nextProps.onDropContentClick;
});
NotificationItems.displayName = "NotificationItems";
export default NotificationItems;